import { render } from "./Coursework-modal.vue?vue&type=template&id=69d91ef3&scoped=true&lang=html"
import script from "./Coursework-modal.vue?vue&type=script&lang=js"
export * from "./Coursework-modal.vue?vue&type=script&lang=js"

import "./Coursework-modal.vue?vue&type=style&index=0&id=69d91ef3&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69d91ef3"]])

export default __exports__